import elementExists from "../../utils/elementExists";
import Swiper, { Pagination, Navigation } from 'swiper';
import pauseVideos from "../../utils/pauseVideo";

const MediaGallery = function () {
    // set this to the container class for the modal that should be opened
    const ModalClass = '.modal';
    // set this to the item that will be clicked to open the modal as well as to set the current index
    const TargetIndexClass = '.mosaic__block--button';
    // set this to the class for the slider within the modal
    const ModalSliderClass = '.swiper-media-gallery';
    const modals = document.querySelectorAll(ModalClass);
    const inputs = document.querySelectorAll(TargetIndexClass);

    // set the current index based on the item that was clicked
    // shoudl have data-index="i"
    let currentIndex = 0;
    if (elementExists(inputs, true)) {
        inputs.forEach(input => input.addEventListener('click', evt => {
            currentIndex = evt.currentTarget.dataset.index.toString();
        }))
    }

    if (elementExists(modals, true)) {
        modals.forEach(target => {
            // on modal shown, start the swiper
            target.addEventListener('shown.bs.modal', function (event) {
                const modal = event.target;
                const el = modal.querySelector(ModalSliderClass);
                if (elementExists(el)) {
                    const btnPrev = el.closest('.modal').querySelector('.swiper-button-prev');
                    const btnNext = el.closest('.modal').querySelector('.swiper-button-next');
                    const swiper = new Swiper(el, {
                        loop: true,
                        direction: 'horizontal',
                        spaceBetween: 50,
                        slidesPerView: 1,
                        centeredSlides: true,
                        loop: false,
                        preventClicks: true,
                        navigation: {
                            prevEl: btnPrev,
                            nextEl: btnNext
                        },
                        on: {
                            slideChange: function (swiper) {
                                pauseVideos(modal);
                            }
                        }
                    })
                    swiper.slideTo(currentIndex);
                }
            })

            // on modal close stop the video
            target.addEventListener('hidden.bs.modal', function (event) {
                pauseVideos(event.target);
            })
        });
    }

    // Hover Effect //
    let mosaic = document.querySelectorAll('.mosaic');
    let mosaicBlock = document.querySelectorAll('.mosaic__block');
    if (elementExists(mosaic, true)) {
        mosaic.forEach(el => {
            el.addEventListener('mouseenter', (event) => {
                mosaicBlock.forEach(on => {
                    on.classList.add('darken');
                });
            });
            el.addEventListener('mouseleave', (event) => {
                mosaicBlock.forEach(on => {
                    on.classList.remove('darken');
                });
            });
        });
    }
}


export default MediaGallery;
